require('./brokerHirePensionPlanStep2.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');

const { getLanguage, formatText, FormattedText } = require('core/i18n').i18n;
const moment = require('moment');
// @ components
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const { OKMessage } = require('commonsComponents/OKMessage');
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');
const BrokerHirePensionPlanDetails = require('../brokerHirePensionPlanDetails/brokerHirePensionPlanDetails');
const { BrokerPlanLegalDocumentDisclaimer } = require('components/broker/brokerPlanLegalDocumentDisclaimer/brokerPlanLegalDocumentDisclaimer');
import BrokerLegalDocumentation from 'components/broker/brokerLegalDocumentation/brokerLegalDocumentation';
// @ constants
const { HIRE_PENSION_PLAN_GDPR_PID } = require('constants/gdprPlacementIds');
const { DEFAULT_TRANSLATION_TEXT_MISSING_VALUE, DEFAULT_TRANSLATION_TEXT } = require('constants/translations')
const {
    BROKER_HIRE_PENSION_PLAN_ID,
    messages: {BROKER_HIRE_PENSION_PLAN_AND_GDPR}
 } = require('constants/operationTypes');
const {
    API_ENTERPRISE_NUMBER,
    API_CENTER,
    DATE_FORMAT_API_DAY_MONTH_YEAR,
    DATE_FORMAT_API_MONTH_DAY_YEAR,
    SECOND_STEP,
    BROKER_PRODUCT_TYPE_PLANS
} = require('constants/index');

//@ContactCenter
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const WebappRender = require('components/conditionalRender/webappRender')

class BrokerHirePensionPlanStep2 extends React.Component {
    constructor (props) {
        super(props);
    }

    buildDetails () {
        const {
            accountNumber,
            annualIncrement,
            annualIncrementPercentage,
            initialContribution,
            participant,
            pensionPlanGestor,
            pensionPlanName,
            pensionPlanVocation,
            periodicity,
            periodicityAmount,
            periodicityDate,
            isPeriodicContributionAvailable
        } = this.props;

        const actualDate = getLanguage() == 'en' ? moment().format(DATE_FORMAT_API_MONTH_DAY_YEAR) : moment().format(DATE_FORMAT_API_DAY_MONTH_YEAR);

        return (
            <BrokerHirePensionPlanDetails
                accountNumber={accountNumber}
                annualIncrement={annualIncrement}
                annualIncrementPercentage={annualIncrementPercentage}
                initialContribution={initialContribution}
                orderDate={actualDate}
                participant={participant}
                pensionPlanGestor={pensionPlanGestor}
                pensionPlanName={pensionPlanName}
                pensionPlanVocation={pensionPlanVocation}
                periodicity={periodicity}
                periodicityAmount={periodicityAmount}
                periodicityDate={periodicityDate}
                isPeriodicContributionAvailable={isPeriodicContributionAvailable}
            />
        );
    }

    buildDisclaimerCheckbox() {
        const { immPensionPlan, immHirePensionPlan, onToggleDisclaimer } = this.props;
        let documentsNotRead = null;
        if (immHirePensionPlan.getIn(['steps', SECOND_STEP, 'showWarning'])) {
            documentsNotRead = (
                <div className="hire-investment-step2__warning-message">
                    <OKMessage type="warning">
                        <FormattedText value="brokerLegalDocumentation-documentsRead" />
                    </OKMessage>
                </div>
            );
        }

        return (
            <WebappRender>
                <BrokerLegalDocumentation
                    className="hire-investment-step2__documentation-box"
                    isAportation={false}
                    productDefinition={immPensionPlan.getIn(['pensionPlan', 'name'])}
                    productType={BROKER_PRODUCT_TYPE_PLANS}
                    planDgsCode={immPensionPlan.getIn(['pensionPlan', 'dgscode'])}
                    reportCompleted={() => this.showSignaturePattern()}
                />
                {documentsNotRead}
                <div className="hire-pension-plan-step2__read-terms">
                    <BrokerPlanLegalDocumentDisclaimer
                        disclaimerErrorState={immHirePensionPlan.getIn(['steps', SECOND_STEP, 'disclaimerInvalid'])}
                        disclaimerErrorMessage={formatText('brokerHirePlansStep2-disclaimerError')}
                        disclaimerChecked={immHirePensionPlan.getIn(['steps', SECOND_STEP, 'disclaimerChecked'])}
                        onDisclaimerCheckChange={onToggleDisclaimer}
                        planName={immPensionPlan.getIn(['pensionPlan', 'name'])}
                        planDgsCode={immPensionPlan.getIn(['pensionPlan', 'dgscode'])}
                        planSecId={immPensionPlan.getIn(['pensionPlan', 'secId'])}
                        isAportation={false}
                    />
                </div>
            </WebappRender>
        );
    }

    showSignaturePattern() {
        this.props.setDocumentsRead();
    }

    buildGestorMessage() {
        const { pensionPlanGestor, immBrokerProductAdvancedSearch } = this.props;

        let gestorMessage;
        const immInstrumentList = immBrokerProductAdvancedSearch.getIn(['results','plans','instrumentsList']);
        if (!!immInstrumentList) {
            const provider = immInstrumentList.getIn([ 0, 'provider'])
            switch (provider) {
                case 'AXA-WINTERTHUR':
                    gestorMessage = formatText('brokerHirePlansStep2-gestorMessageAXA');
                    break;
                case 'CAIXABANK':
                    gestorMessage = formatText('brokerHirePlansStep2-gestorMessageCAIXABANK');
                    break;
                case 'BBVA':
                    gestorMessage = formatText('brokerHirePlansStep2-gestorMessageBBVA');
                    break;
                case 'CASER':
                    gestorMessage = formatText('brokerHirePlansStep2-gestorMessageCASER');
                    break;
                case 'SANTANDER':
                    gestorMessage = formatText('brokerHirePlansStep2-gestorMessageSANTANDER');
                    break;
                case 'VIDACAIXA':
                    gestorMessage = formatText('brokerHirePlansStep2-gestorMessageVIDACAIXA');
                    break;
                default:
                    gestorMessage = null;
                    break;
            }
        } else {
            if(pensionPlanGestor.toLowerCase().includes('axa')){
                gestorMessage = formatText('brokerHirePlansStep2-gestorMessageAXA');
            }else if(pensionPlanGestor.toLowerCase().includes('bbva')){
                gestorMessage = formatText('brokerHirePlansStep2-gestorMessageBBVA');
            }else if(pensionPlanGestor.toLowerCase().includes('caixabank')){
                gestorMessage = formatText('brokerHirePlansStep2-gestorMessageCAIXABANK');
            }else if(pensionPlanGestor.toLowerCase().includes('caser')){
                gestorMessage = formatText('brokerHirePlansStep2-gestorMessageCASER');
            }else if (pensionPlanGestor.toLowerCase().includes('santander')) {
                gestorMessage = formatText('brokerHirePlansStep2-gestorMessageSANTANDER');
            }else if (pensionPlanGestor.toLowerCase().includes('caixa')){
                gestorMessage = formatText('brokerHirePlansStep2-gestorMessageVIDACAIXA');
            }else {
                gestorMessage = null;
            }
        }
        if (!!gestorMessage && gestorMessage !== DEFAULT_TRANSLATION_TEXT_MISSING_VALUE && gestorMessage !== DEFAULT_TRANSLATION_TEXT) {
            return(
                <div className="hire-pension-plan-step2__gestor-message-container">
                    {gestorMessage}
                </div>
            );
        }
    }
    render () {
        const {
            productNumber,
            contractNumber,
            immHirePensionPlan
        } = this.props;

        const operationParams = {
            originAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${productNumber}${contractNumber}`
        };
        const hiringDetails = this.buildDetails();
        const disclaimerCheckbox = this.buildDisclaimerCheckbox();
        const operative = formatText("operatives-brokerHirePensionPlan")
        const consentElement = (<OKConsents placementId={HIRE_PENSION_PLAN_GDPR_PID} />);
        let signaturePattern = null;
        if (immHirePensionPlan.getIn(['steps', SECOND_STEP, 'disclaimerChecked'])) {
            signaturePattern = (
                <div className="hire-pension-plan-step2__signature-pattern-container">
                    <GDPRSignaturePattern
                        operationType={BROKER_HIRE_PENSION_PLAN_ID}
                        operationParams={operationParams}
                        multiOTPMessageCode={BROKER_HIRE_PENSION_PLAN_AND_GDPR}
                        isWealth={true}
                    />
                </div>
            )
        }
        const gestorMessage = this.buildGestorMessage();

        return (
            <div>
                <h2 className="hire-pension-plan-step2__title">
                    <FormattedText value="brokerHirePlansStep2-title"/>
                </h2>
                <ContactCenterRender>
                    <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                </ContactCenterRender>
                <FormattedText value="brokerHirePlansStep2-subtitle" className="hire-pension-plan-step2__description"/>
                {hiringDetails}
                {gestorMessage}
                {consentElement}
                {disclaimerCheckbox}
                <ContactCenterRender>
                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                </ContactCenterRender>
                {signaturePattern}
            </div>
        );
    }
}

BrokerHirePensionPlanStep2.propTypes = {
    accountNumber: PropTypes.string.isRequired,
    annualIncrement: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    annualIncrementPercentage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    initialContribution: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    immAccount: PropTypes.object,
    participant: PropTypes.string.isRequired,
    productNumber: PropTypes.string.isRequired,
    contractNumber: PropTypes.string.isRequired,
    pensionPlanGestor: PropTypes.string.isRequired,
    pensionPlanName: PropTypes.string.isRequired,
    pensionPlanVocation: PropTypes.string.isRequired,
    periodicity: PropTypes.string.isRequired,
    periodicityAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    periodicityDate: PropTypes.object.isRequired,
    immPensionPlan: PropTypes.object.isRequired,
    immBrokerProductAdvancedSearch: PropTypes.object.isRequired,
    immHirePensionPlan: PropTypes.object.isRequired,
    onToggleDisclaimer: PropTypes.func.isRequired,
    isPeriodicContributionAvailable: PropTypes.bool.isRequired,
    setDocumentsRead: PropTypes.func.isRequired
};


module.exports = BrokerHirePensionPlanStep2;
